import Main from './Main';

export { Main };
export default Main;
